<template>
  <div class="main">
    <div class="image" :style="{backgroundImage:'url('+item.img+')'}">
      <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" style="width:100%">
    </div>
    <div class="footer">
      <table style="width:100%" class="itable">
        <tbody>
        <tr v-for="field in item.data">
          <td>{{field.label}}</td>
          <td>{{field.text}}</td>
        </tr>
        </tbody>
      </table>
      <table style="width:100%">
      <tbody>
        <tr>
          <td>
            <btn b l="Просмотр" t="p" s="s" i="eye"/>
          </td>
          <td class="text-right">
            <btn block l="В корзину" t="s" s="s" i="plus"/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: "cart-item",
    data() {
      return {}
    },
    methods:{

    },
    props: {
      item:{
        type:Object,
        default(){
          return {
            img:"https://www.demon-tweeks.co.uk/oncirrus/3/image/product/zoom/0123456789/0123456789/tornado_.jpg",
            data:[{
              "label":"Группа",
              "text":"Кузовгые"
            },{
              "label":"Тип",
              "text":"Глушители"
            },{
              "label":"Производитель",
              "text":"Bandoss"
            },{
              "label":"Цена",
              "text":"1000 тенге"
            }]
          };
        }
      }
    }
  }
</script>

<style scoped>
  .main {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0px 6px 0px rgba(163, 165, 169, 0.5), 0 0 2px rgba(0, 0, 0, 0.25);
    margin:6px 4px ;
    overflow:hidden;
    padding:6px;
  }

  .image {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .image img{
    max-width:100%;
  }

  .footer {
    overflow:hidden;
  }

  .itable td{
    border-bottom:1px solid lightgrey;
    padding:4px 8px;
    font-size:11px;
  }
  .itable td:first-child{
    text-align: left;
  }
  .itable td:last-child{
    text-align: right;
  }

  .itable tr:last-child td{
    border-bottom: none;
  }
</style>
